<template>
    <div class="vx-card p-8">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3>Chi tiết đánh giá, phản hồi</h3>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false"
                          name="branch"
                          disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Khách hàng</label>
                <v-select class="w-full" v-model="selectedCustomer" :options="customerData" :clearable="false"
                          name="customer" disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4" v-if="isBooking">
                <label class="vs-input--label">Thời gian đặt</label>
                <vs-input class="w-full" v-model="dateTimeBooking" name="time" disabled>
                </vs-input>
            </div>
        </div>

        <div class="vx-row" v-if="!isCombo && isBooking">
            <div class="vx-col md:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Nhóm dịch vụ</label>
                <v-select class="w-full" v-model="selectedBeautyService" :options="beautyServiceData" :clearable="false"
                          name="doctor" disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Chỉ tiêu</label>
                <v-select class="w-full" v-model="selectedBeautyServicePack" :options="beautyServicePackData"
                          :clearable="false" name="doctor" disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Bác sĩ</label>
                <v-select class="w-full" v-model="selectedDoctor" :options="doctorData" :clearable="false" name="doctor"
                          disabled>
                </v-select>
            </div>
        </div>

        <div class="vx-row" v-if="isCombo && isBooking">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Gói dịch vụ</label>
                <v-select class="w-full" v-model="selectedBeautyCombo" :options="beautyComboData" :clearable="false"
                          name="beautyCombo" disabled>
                </v-select>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4" v-if="selectedDepartmentValue">
                <label class="vs-input--label">Phòng ban</label>
                <v-select class="w-full" v-model="selectedDepartment" :options="departmentData" :clearable="false"
                          name="department" disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Loại phản ánh</label>
                <v-select class="w-full" v-model="selectedType" :options="typeOptions" :clearable="false"
                          name="beautyCombo"
                          disabled>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label">Chất lượng</label>
                <star-rating v-model="rate" :star-size="25" :show-rating="false" :read-only="true" :border-width="4"
                             border-color="#F3D23E"
                             active-color="#F3D23E" :rounded-corners="true"
                             :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                             class="mt-2"></star-rating>
                <!-- <awesome-vue-star-rating :star="rate" disabled :maxstars="5" starsize="2x" :hasresults="false"
                    :hasdescription="false"></awesome-vue-star-rating> -->
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-full mt-4">
                <label class="vs-input--label">Nội dung</label>
                <vs-textarea class="w-full" v-model="content" disabled/>
            </div>

            <div class="vx-col md:w-1/2 sm:w-full md:mt-4">
                <label class="vs-input--label">Người liên quan</label>
                <vs-textarea class="w-full" v-model="peopleInvolved" disabled/>
            </div>

            <div class="vx-col md:w-1/2 sm:w-full">
                <label class="vs-input--label">Phản hồi</label>
                <span class="text-sm text-danger">*</span>
                <vs-textarea class="w-full" v-model="reply" v-validate="'required'" name="reply"
                             :disabled="statusFeedback === 2"/>
                <span class="text-danger text-sm">{{ errors.first('reply') }}</span>
            </div>

            <div class="vx-col md:w-1/2 sm:w-full" v-if="statusFeedback === 2">
                <label class="vs-input--label">Kết quả</label>
                <span class="text-sm text-danger">*</span>
                <vs-textarea class="w-full" v-model="result"/>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
                <div class="mt-8 table_media">
                    <vs-table stripe :data="videoFeedback" noDataText="Không có dữ liệu" pagination max-items="5">
                        <template slot="header">
                            <h4 class="mb-8">
                                Danh sách file phản ánh
                            </h4>
                        </template>
                        <template slot="thead">
                            <vs-th>
                                STT
                            </vs-th>
                            <vs-th>
                                Tên file
                            </vs-th>
                            <vs-th>
                                Hành động
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].stt">
                                    {{ tr.stt }}
                                </vs-td>

                                <vs-td :data="data[indextr].fileName">
                                    {{ tr.fileName }}
                                </vs-td>

                                <vs-td>
                                    <div>
                                        <vx-tooltip text="Xem" position="top">
                                            <feather-icon icon="EyeIcon" class="action-success mt-4 mr-2"
                                                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                          @click="previewMedia(tr)"/>
                                        </vx-tooltip>
                                        <vx-tooltip text="Tải về" position="top">
                                            <feather-icon icon="DownloadIcon" class="action-success mt-4 mr-2"
                                                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                          @click="downloadFile(tr, indextr)"/>
                                        </vx-tooltip>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
                <div class="mt-8 table_media">
                    <vs-table stripe :data="files" noDataText="Không có dữ liệu" pagination max-items="5">
                        <template slot="header">
                            <div class="vx-row w-full">
                                <h4 class="vx-col w-1/2 mb-8">
                                    Danh sách file phản hồi
                                </h4>
                                <div class="vx-col w-1/2">
                                    <vs-button class="float-right" color="primary" icon-pack="feather" icon="icon-plus"
                                               @click="addFileReply" :disabled="isReply">Thêm file
                                    </vs-button>
                                </div>
                            </div>
                        </template>
                        <template slot="thead">
                            <vs-th>
                                STT
                            </vs-th>
                            <vs-th>
                                Tên file
                            </vs-th>
                            <vs-th>
                                Hành động
                            </vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].stt">
                                    {{ tr.stt }}
                                </vs-td>

                                <vs-td :data="data[indextr].fileName" class="cursor-pointer">
                                    {{ tr.fileName }}
                                </vs-td>

                                <vs-td>
                                    <div>
                                        <vx-tooltip text="Xem" position="top" v-if="data[indextr].id">
                                            <feather-icon icon="EyeIcon" class="action-success mt-4 mr-2"
                                                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                          @click="previewMedia(tr)"/>
                                        </vx-tooltip>
                                        <vx-tooltip text="Xóa" position="top">
                                            <feather-icon icon="TrashIcon" class="text-danger mt-4 mr-2"
                                                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                          @click="confirmDelete(tr)"/>
                                        </vx-tooltip>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
                <vs-input class="hidden" type="file" id="uploadFile" @change="uploadFile($event)" multiple></vs-input>
            </div>
        </div>

        <div class="vx-row mt-4">
            <div class="vx-col w-full float-right">
                <div class="mt-4 flex flex-wrap mb-5">
                    <vs-button class="ml-auto mt-2" @click="saveData" :disabled="!validateForm"
                               v-if="isPermissionUpdateFeeback">Phản hồi
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/user/feedback')">Quay lại
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import vSelect from 'vue-select';
import authConfig from '@/../auth_config.json';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import StarRating from 'vue-star-rating';
import AwesomeVueStarRating from "awesome-vue-star-rating";
import {isAPI} from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        AgGridVue,
        StarRating,
        AwesomeVueStarRating,
    },
    data() {
        return {
            feedbackInfo: {},
            feedbackId: null,
            branchOptions: [],
            selectedBranchValue: null,
            beautyServiceData: [],
            selectedBeautyServiceValue: null,
            beautyServicePackData: [],
            selectedBeautyServicePackValue: null,
            customerData: [],
            selectedCustomerValue: null,
            doctorData: [],
            selectedDoctorValue: null,
            isBooking: false,
            isCombo: false,
            dateTimeBooking: null,
            videoFeedback: [],
            beautyComboData: [],
            selectedBeautyComboValue: null,
            reply: null,
            result: null,
            content: null,
            typeOptions: [
                {value: 1, label: 'Thái độ phục vụ'},
                {value: 2, label: 'Chất lượng dịch vụ'},
                {value: 3, label: 'Giá cả'},
                {value: 4, label: 'Chính sách bảo hành'},
                {value: 5, label: 'Khác'}
            ],
            rate: 0,
            selectedTypeValue: null,
            files: [],
            dataDelete: {},
            statusFeedback: null,
            departmentData: [],
            selectedDepartmentValue: null,
            isReply: false,
            peopleInvolved: null,
        }
    },

    created() {

        let check = false;
        this.$eventBus.$on("notify-detail-feedback", ($event) => {
            if ($event) this.initScreen();
            check = true;
        })
        if (!check) this.initScreen();
    },

    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value
                };
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },
        selectedCustomer: {
            get() {
                let obj = this.customerData.find(x => x.value === this.selectedCustomerValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value
                };
            },
            set(obj) {
                this.selectedCustomerValue = obj ? obj.value : null;
            }
        },
        selectedDoctor: {
            get() {
                let obj = this.doctorData.find(x => x.value == this.selectedDoctorValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        selectedBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value == this.selectedBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyServiceValue = obj ? obj.value : null;
            }
        },
        selectedBeautyServicePack: {
            get() {
                let obj = this.beautyServicePackData.find(x => x.value == this.selectedBeautyServicePackValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyServicePackValue = obj ? obj.value : null;
            }
        },
        selectedBeautyCombo: {
            get() {
                let obj = this.beautyComboData.find(x => x.value == this.selectedBeautyComboValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyComboValue = obj ? obj.value : null;
            }
        },

        selectedType: {
            get() {
                let obj = this.typeOptions.find(x => x.value == this.selectedTypeValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedTypeValue = obj ? obj.value : null;
            }
        },

        selectedDepartment: {
            get() {
                let obj = this.departmentData.find(x => x.value == this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
            }
        },

        validateForm() {
            return !this.errors.any();
        },
    },

    methods: {
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            this.branchOptions = branchList.map(x => {
                return {label: x.organizationBranchName, value: x.id}
            });

            let id = this.$route.query.id;
            if (id) {
                this.feedbackId = parseInt(id);
                await this.findById();
                await this.getCustomerData();
                await this.getDepartmentData();
            }
        },

        findById() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-booking-feedback/find-by-id/${this.feedbackId}`).then(async res => {
                    this.feedbackInfo = res.data;
                    this.selectedBranchValue = res.data.organizationBranchId;
                    this.selectedCustomerValue = res.data.loyaltyCustomer.id;
                    this.selectedDepartmentValue = res.data.departmentId;
                    this.files = res.data.files.map(q => {
                        q.stt = res.data.files.indexOf(q) + 1;
                        q.fileName = JSON.parse(q.metaData).name;
                        return q;
                    });
                    this.selectedTypeValue = res.data.type;
                    this.content = res.data.content;
                    this.reply = res.data.reply;
                    this.result = res.data.result;
                    if (this.reply) this.isReply = true;
                    this.statusFeedback = res.data.status;
                    this.rate = res.data.rate;
                    this.peopleInvolved = res.data.peopleInvolved;
                    let media = res.data.videos.concat(res.data.images, res.data.records, res.data.videos)
                    this.videoFeedback = media.map(q => {
                        q.stt = media.indexOf(q) + 1;
                        q.fileName = JSON.parse(q.metaData).name;
                        return q;
                    });
                    if (res.data.beautyBooking) {
                        this.isBooking = true;
                        let dataBooking = res.data.beautyBooking.beautyBookingDetails[0];
                        this.dateTimeBooking = moment(dataBooking.bookingTime).format('DD/MM/YYYY HH:mm');
                        if (dataBooking.beautyServicePackage) {
                            this.selectedDoctorValue = dataBooking.performerId;
                            this.isCombo = false;
                            this.selectedBeautyServicePackValue = dataBooking.beautyServicePackage.id;
                            await this.getBeautyServicePack();
                            await this.getBeautyService();
                            await this.getDoctorData();
                        }
                        if (dataBooking.beautyPackageCombo) {
                            this.isCombo = true;
                            await this.getBeautyCombo();
                            this.selectedBeautyComboValue = dataBooking.beautyPackageCombo.id;
                        }
                    }
                    resolve();
                    setTimeout(() => this.$vs.loading.close(), 1000)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getCustomerData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.customerData = [];
                let url = `/loyalty/customer/find?keySearch=${this.feedbackInfo.loyaltyCustomer.fullName}`
                this.$crm.get(url).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.customerData = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve(res);
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', {}).then(res => {
                    this.departmentData = res.data.map(el => {
                        return {
                            value: el.id,
                            label: el.departmentName
                        }
                    })
                    resolve(res);
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },

        getBeautyService() {
            return new Promise((resolve, reject) => {
                this.beautyServiceData = [];
                // this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', {organizationBranchId: this.selectedBranchValue}).then(res => {
                    res.data.content.forEach(x => {
                        let dataPack = x.beautyServicePackages.find(t => t.id == this.selectedBeautyServicePackValue);
                        if (dataPack) this.selectedBeautyServiceValue = x.id;
                    });
                    this.beautyServiceData = res.data.content.map(el => {
                        return {
                            label: el.code + '-' + el.name,
                            value: el.id
                        }
                    });
                    resolve()
                    // this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.beautyServicePackData = [];
                // this.$vs.loading();
                this.$crm.post('/beauty-service-package/find-by-condition', {organizationBranchId: this.selectedBranchValue}).then(res => {
                    this.beautyServicePackData = res.data.content.map(el => {
                        return {
                            label: el.code + '-' + el.name,
                            value: el.id
                        }
                    });
                    resolve()
                    // this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getBeautyCombo() {
            return new Promise((resolve, reject) => {
                this.beautyComboData = [];
                this.$crm.post('/beauty-package-combo/find-by-condition', {organizationBranchId: this.selectedBranchValue}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyComboData = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    // this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                this.doctorData = [];
                // this.$vs.loading();
                this.$crm.get(`/beauty-booking/get-list-doctor-department?organizationBranchId=${this.selectedBranchValue}`).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorData = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    // this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        previewMedia(item) {
            window.open(item.url);
        },

        downloadFile(item, index) {
            fetch(authConfig.cdnImage + item.fileId).then(resp => resp.blob()).then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = `file_feedback_${index}`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(() => alert('An error sorry'));
        },

        addFileReply() {
            document.getElementById('uploadFile').click();
        },

        uploadFile(data) {
            let file = [...data.target.files];
            this.files = this.files.concat(file);
            this.files.forEach((q) => {
                if (!q.fileId) q.fileName = q.name;
                q.stt = this.files.indexOf(q) + 1;
                return q;
            });
        },

        confirmDelete(data) {
            this.dataDelete = data;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('warningMenuCustomer.titleWarning'),
                text: 'Bạn có chắc chắn muốn xóa file này không ?',
                accept: this.deleteFile,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteFile() {
            this.files = this.files.filter(t => t.stt != this.dataDelete.stt);
            this.files.forEach((q) => {
                q.stt = this.files.indexOf(q) + 1;
                return q;
            });
        },

        async saveData(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            this.$vs.loading();
            let dto = {
                id: this.feedbackId,
                reply: this.reply,
                result: this.result
            }
            const blob = new Blob([JSON.stringify(dto)], {type: 'application/json'});
            const formData = new FormData();
            this.files.forEach(x => formData.append('files', x));
            formData.append('dto ', blob);

            this.$crm.post('/beauty-booking-feedback/update-status', formData).then(() => {
                this.$vs.notify({
                    text: `Phản hồi thành công!'`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$router.push('/user/feedback')
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        isPermissionUpdateFeeback() {
            return isAPI(this, constAPI.beauty_feedback_update);
        },
    },
}
</script>

<style>
.table_media .vs-table--thead {
    color: rgba(var(--vs-primary), 1) !important;
}
</style>
